const locale = {
  placeholder: 'Odaberite vrijeme',
};

export default locale;
